import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {I18nModule} from '@spartacus/core';
import {IconModule, TruncateTextPopoverModule} from '@spartacus/storefront';
import {CustomCardComponent} from './custom-card.component';
import {CustomIconsModule} from '../../../../../custom/icons/custom-icons.module';

@NgModule({
  imports: [CommonModule, I18nModule, TruncateTextPopoverModule, CustomIconsModule, IconModule],
  declarations: [CustomCardComponent],
  exports: [CustomCardComponent],
})
export class CustomCardModule {}
